<template>
  <ReceiptBorderIcon class="fill-surface-grey-light w-full" />
  <div class="p-4 py-8 bg-surface-grey-light w-full">
    <h1 class="h4 pb-6">{{ $t('checkout.receipt') }}</h1>

    <div class="mb-4 space-y-6 grow overflow-y-auto">
      <CartListItem v-for="item in cart.items" :key="item.id" :item="item" />
    </div>

    <div
      class="p-4 mt-6 bg-surface-light rounded-md border border-surface-grey"
    >
      <CartSummaryTable ref="summaryTable" />
    </div>

    <!-- The backend has already escaped or sanitized the message (organizer text shown to buyers who missed the sso price) -->
    <div
      v-if="cart.receiptOrder.additional_receipt_message"
      class="mt-6 prose prose-sm max-w-none text-text wrap-anywhere"
      v-html="cart.receiptOrder.additional_receipt_message"
    />
  </div>
  <ReceiptBorderIcon class="rotate-180 fill-surface-grey-light w-full" />
</template>

<script setup lang="ts">
  import { onMounted, onUnmounted, ref } from 'vue';

  import { fetchReceipt } from '@/api/receipt';
  import CartListItem from '@/components/checkout/CheckoutListItem.vue';
  import CartSummaryTable from '@/components/checkout/CheckoutSummaryTable.vue';
  import { useCartStore } from '@/stores/cart';
  import type { APIReceipt } from '@/types';
  import { getUrlParam } from '@/utils/urlParams';
  import { useWebsocketStore } from '@/websocket/websocket';

  import ReceiptBorderIcon from '../icons/ReceiptBorderIcon.vue';

  const cart = useCartStore();
  const websocket = useWebsocketStore();
  const rtoken = getUrlParam('rtoken');
  // console.log('rtoken', rtoken);
  

  onMounted(() => {
    console.log('CheckoutReceipt mounted');
    console.log('rtoken on mount', rtoken);
    if (rtoken) {
      websocket.rtoken = rtoken;
      websocket.saveRtoken(rtoken);
      websocket.open();
      const txnid = getUrlParam('txnid');
      console.log('txnid', txnid);
      if (txnid && !cart.ReceiptConfirmPaymentsSent[txnid]) {
        cart.ReceiptConfirmPaymentsSent[txnid] = true;
        websocket.send('receipt', { rtoken, txnid }, undefined);
        console.log('RECEIPT MESSAGE SENT 1');
      }
      else if(!txnid){ 
        websocket.send('receipt', { rtoken, txnid }, undefined);
        console.log('RECEIPT MESSAGE SENT 2');
      }
    }
    else{
      // Fallback: fetch receipt via API
      (async () => {
        const orderid = getUrlParam('orderid');
        const mailid = getUrlParam('mailid');
        if (orderid && mailid) {
          const receiptData: APIReceipt = await fetchReceipt(orderid, mailid);
          cart.setAPIReceipt(receiptData);
          console.log('RECEIPT MESSAGE SENT 3');
        } 
        else {
          // No rtoken, orderid or mailid provided, go back to home
          window.location.href = '/';
        }
      })();
    }
  });

  onUnmounted(() => {
    websocket.close();
    // Clean up any other resources if necessary
    console.log('CheckoutReceipt unmounted, websocket closed');
    cart.resetCart();
  });
  

  defineProps<{
    nextLink?: string;
  }>();

  const summaryTable = ref<InstanceType<typeof CartSummaryTable>>();

  function calculateSummary() {
    if (summaryTable.value) {
      summaryTable.value.loadCodes();
    }
  }

  defineExpose({
    calculateSummary,
  });
</script>
